import React, { useState, useContext, useEffect } from "react";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useShareGroupScreen } from "./hooks/useShareGroupScreen";
import FInputt from "../../components/FInputt/FInputt";
import { useFormat } from "../../hooks/useFormat";
import { useGroup } from "../../hooks/useGroups";
import { AuthContext } from "../../context/AuthContext";
import FBannerTitleButton from "../../components/FspendComponents/FBannerSpend/FBannerTitleButton";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FContainer from "../../components/FContainer/FContainer";
import FBannerSpend from "../../components/FspendComponents/FBannerSpend/FBannerSpend";

import { PencilOutline, TrashOutline } from "react-ionicons";
import Swal from "sweetalert2";

const ShareGroupScreen = ({ param }) => {
  const { getBase64 } = useFormat();

  const {
    arrayGroups,
    setArrayGroups,
    onClickGroups,
    add,
    setAdd,
    edit,
    setEdit,
    formikAdd,
    formikEdit,
    srcFileZone,
    setSrcFileZone,
    route,
  } = useShareGroupScreen();

  const { loading, checkToken } = useContext(AuthContext);
  const { groups, loadGroups, setGroups } = useGroup();
  const [isRefreshing, setIsRefreshing] = useState(false);
  //const isFocused = useIsFocused();
  const { getMembers, members, deleteMember, deleteGroup, setMembers } =
    useGroup();

  useEffect(() => {
    const _loadGroups = async () => {
      let _group = await loadGroups()
      if (_group[1] == undefined) {
        route("/AddPerson");
      }
    }
    _loadGroups();
  }, []);

  return (
    <>
      <FBannerSpend
        imageUrl={require("../../components/assets/images/share-fiado-banner.png")}
        description="Saldo Disponible"
      />
      <FContainer>
        {arrayGroups?.length > 0
          ? arrayGroups.map((group) => (
            <div className="border-0 w-full grid grid-cols-12 shadow-Box rounded-2xl px-2 py-3 my-2 cursor-pointer">
              <div
                className="border-0 col-span-2 grid place-items-center"
              >
                <img
                  src={group.picture}
                  className="w-[40px] xxxs:w-[50px] h-[40px] xxxs:h-[50px]"
                  alt=""
                />
              </div>
              <div
                className="border-0 col-span-9 grid grid-cols-1 items-center font-regular text-[13px] pl-2"
                onClick={async () => {
                  let _members = await getMembers(group.id);
                  route("/DisperseScreen", {
                    state: {
                      members: _members,
                      groupId: group.id,
                    },
                  });
                }}
              >
                <div className="border-0 col-span-1 grid items-center font-bold">
                  {group.name}
                </div>
                <div className="border-0 col-span-1 grid items-start font-medium">
                  {group.description}
                </div>
              </div>
            </div>
          ))
          : null}
      </FContainer>
    </>
  );
};

export default ShareGroupScreen;
